import $ from 'jquery';
import 'svgxuse';

export default function utils() {
  
  $('html').removeClass('no-js');
  
}